import { identity, pipe } from 'fp-ts/lib/function';
import * as A from 'fp-ts/Array';
import * as O from 'fp-ts/Option';
import * as R from 'fp-ts/Record';

import { memoizeWith } from './memoizeWith';

const kitColorIcons: Record<string, string> = {
  black: '#000',
  blue: '#025D8C',
  brown: '#604830',
  gray: '#919999',
  green: '#3C9A62',
  grey: '#919999',
  orange: '#FF6600',
  amber: '#FF6600',
  pink: '#EE5D88',
  red: '#DE0000',
  white: '#FFF',
  yellow: '#FFCC00',
};

const getColorHex = (v: string) => R.lookup(v)(kitColorIcons);

const matchColorNamesToHexes = (name: string | undefined) =>
  pipe(
    name,
    O.fromNullable,
    O.map((n) => n.toLowerCase()),
    O.chain(getColorHex),
  );

export const deriveKitColor = memoizeWith(
  identity,
  (kitName: string): string[] => {
    const colorMatches = Object.keys(kitColorIcons).join('|');

    const regex = new RegExp(`(${colorMatches})`, 'gi');

    return pipe(
      kitName.match(regex),
      O.fromNullable,
      O.map(A.filterMap(matchColorNamesToHexes)),
      O.getOrElse((): string[] => []),
    );
  },
);
